// Standalone IIFE browser distribution entry point.
// Ensures `var Flux` evaluates directly to the single canonical API object.

import fullApi from './full.js';

export default fullApi;
